// @ts-check
import { Component } from '@verndale/core';
import { KEYCODE } from '../../utils';
// import { createFocusTrap } from 'focus-trap';

class Module extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $header: this.el.closest('.header'),
      $input: this.el
        .closest('.header')
        .querySelectorAll('.header-search__input'),
      $results: this.el
        .closest('.header')
        .querySelectorAll('.header-search__results')
    };

    this.endpoint = this.dom.$header.dataset.searchEndpoint;
    this.popularSearches = this.dom.$header.dataset.popularSearchesLabel;
    this.suggestedResults = this.dom.$header.dataset.suggestedResultsLabel;
    this.viewAllUrl = this.dom.$header.dataset.viewAllUrl;
    this.controller = null;

    const MOBILE_BREAKPOINT = 1024;
    this.mobileBreakpoint = window.matchMedia(
      `(max-width:${MOBILE_BREAKPOINT})px`
    );
    this.headerSearchClass = this.mobileBreakpoint.matches
      ? '.header-search--mobile'
      : '.header-search--desktop';

    this.form = this.el
      .closest('.header')
      .querySelector(this.headerSearchClass);
    this.searchInput = this.form.querySelector('.header-search__input');
  }

  addListeners() {
    this.el.addEventListener('submit', (e) => this.handleSubmit(e));
    this.dom.$input.forEach((input) =>
      input.addEventListener('input', (e) => this.handleInput(e))
    );
    this.el.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleSubmit(e) {
    const { value } = e.currentTarget.querySelector('.header-search__input');

    if (value.length) {
      e.preventDefault();
      window.location.href = `${this.viewAllUrl}${value}`;
    }
  }

  handleInput(e) {
    const { value } = e.currentTarget;
    this.dom.$input.forEach((input) => {
      if (input.closest(this.headerSearchClass)) {
        input.closest(this.headerSearchClass).dataset.showResults = true;
        input.value = value;
      }
    });

    if (this.controller) this.controller.abort();

    if (value.length > 1) this.fetchResults(value);
    else this.emptyResults();

    document.addEventListener('click', this.handleClickOutsideForm.bind(this));
  }

  handleKeyDown(e) {
    const isEscapeKey = e.keyCode === KEYCODE.ESCAPE;
    const isTabKey = e.keyCode === KEYCODE.TAB;
    setTimeout(() => {
      if (isEscapeKey) {
        this.handleEscapeKey();
      } else if (isTabKey) {
        this.handleTabKey();
      }
    }, 0);
  }

  handleEscapeKey() {
    if (this.searchInput) {
      this.form.dataset.showResults = false;
      this.searchInput.value = '';
    }
  }

  handleTabKey() {
    if (this.searchInput && !this.form.contains(document.activeElement)) {
      this.form.dataset.showResults = false;
    }
  }

  handleClickOutsideForm(e) {
    if (this.form.contains(e.target)) return;
    if (this.searchInput) this.form.dataset.showResults = false;
    document.removeEventListener('click', this.handleClickOutsideForm);
  }

  fetchResults(value) {
    this.controller = new AbortController();
    const { signal } = this.controller;

    fetch(`${this.endpoint}${value}`, { signal })
      .then((response) => response.json())
      .then((data) => this.renderResults(data))
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error));
  }

  renderResults(data) {
    const template = `
      ${
        data.Popular?.length
          ? `
          <h2 class="header-search__results-heading">${
            this.popularSearches
          }</h2>
          <ul role="list">
        ${data.Popular.map(
          (item) => `
          <li>
            <a href="${item.URL}" class="header-search__results-item">
              ${item.Value}
            </a>
          </li>
        `
        ).join('')}
      </ul>`
          : ''
      }
      ${
        data.Products?.length
          ? `
          <h2 class="header-search__results-heading">${this.suggestedResults.replace(
            '{0}',
            data.Products?.length
          )}</h2>
          <ul role="list">
        ${data.Products.map(
          (item) => `
          <li>
            <a href="${item.URL}" class="header-search__results-item">
              ${item.ProductName}
            </a>
          </li>
        `
        ).join('')}
      </ul>`
          : ''
      }
      <div class="header-search__footer">
        <a class="link link--right-icon" href="${data.ViewAllUrl}">
          ${data.ViewAllText}
        </a>
        <span class="header-search__footer-counter">
          ${data.TotalResultsText}
        </span>
      </div>
    `;

    this.dom.$results.forEach((result) => {
      result.closest('.header-search').dataset.showResults = true;
      result.innerHTML = template;
    });
  }

  emptyResults() {
    this.dom.$results.forEach((result) => (result.innerHTML = ''));
  }
}

export default Module;
